import React from "react";
import EachRowCell from "./EachRowCell";

const headerStyle = {
  display: "flex",
  alignItems: "center",
  background: "#F9FAFB",
  fontWeight: 600,
  fontSize: "13px",
  color: "#374151",
  padding: "12px 16px",
  borderBottom: "1px solid #E5E7EB",
  whiteSpace: "nowrap",
};

const tableWrapStyle = {
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  overflow: "hidden",
};

function ShowAdminView({ refreshPage, allService, allPartner, selectedView }) {
  
  let allServicesData = localStorage.getItem("userDetails");
  if (allServicesData && allServicesData !== "undefined") {
    allServicesData = JSON.parse(allServicesData);
  }
  const isClinicService =  allServicesData.industry === 1 
  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between mobile-admin-view" style={{ gap: "16px" }}>
        {selectedView?.find((ele) => ele.name === "View Services") && (
          <div className="w-45 mobile-card" style={tableWrapStyle}>
            <div style={headerStyle}>
              <div style={{ width: "50%" }}>{isClinicService ? "Specialization": "Services"}</div>
              <div style={{ width: "40%" }}>Action</div>
              <div style={{ width: "35%" }}>Active / In-Active</div>
            </div>
            {allService?.map((ele, idx) => (
              <EachRowCell key={idx} item={ele} currentEdit={"Service"} refreshPage={refreshPage} />
            ))}
          </div>
        )}
        {selectedView?.find((ele) => ele.name === "View Profile") && (
          <div className="w-45 mobile-card" style={tableWrapStyle}>
            <div style={{ ...headerStyle, justifyContent: "space-between" }}>
              <div style={{ width: "40%" }}>Profile</div>
              <div style={{ width: "30%" }}>Commission</div>
              <div style={{ width: "30%", textAlign: "right" }}>Action</div>
            </div>
            {allPartner?.map((ele, idx) => (
              <EachRowCell key={idx} item={ele} currentEdit={"Profile"} refreshPage={refreshPage} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ShowAdminView;
